import React from "react";
import { Grid2 } from "@mui/material";
import { FundamentalsCard } from "../FundamentalsCard";
import { DividendsByInvestmentChart } from "../DividendsChart/DividendsByInvestmentChart";
import { GainLossStatisticsLoader } from "../../../investment/details/GainLossStatisticsLoader";
import { RanksAndRisks } from "../RanksAndRisks";

export interface Props {
  investmentId: number;
  isin: string;
  areDividendsPresent?: boolean;
}

export const FundFundamentalsByInvestmentId = ({
  isin,
  investmentId,
  areDividendsPresent = false,
}: Props) => (
  <Grid2 container spacing={4} width="100%" mt={5}>
    <FundamentalsCard>
      <GainLossStatisticsLoader investmentId={investmentId} />
    </FundamentalsCard>

    {areDividendsPresent && (
      <FundamentalsCard>
        <DividendsByInvestmentChart investmentId={investmentId} />
      </FundamentalsCard>
    )}

    <FundamentalsCard>
      <RanksAndRisks isin={isin} />
    </FundamentalsCard>
  </Grid2>
);
